
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/privateAppsPanel/components/newBlockButton/newBlockButton.scss.css.virtualfile';
        module.exports = {"new-block-button-container":"_new-block-button-container_maqeu_1","newBlockButtonContainer":"_new-block-button-container_maqeu_1"};